import { useContext, useEffect, useState, useRef } from "react"
import { Link, useMatch, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import Spinner from "../../../components/BootstrapCompo"
import { GlobalContext, handleError } from "../../../context/Provider"
import henceforthApi from "../../../utils/henceforthApi"


const SubCategoryEdit = () => {
    const match = useMatch("/category/level-2/edit/:name/:id")
    const navigate = useNavigate()
    const [categoryNameError, setCategoryError] = useState("")
    const [subCategoryName, setSubCategoryName] = useState(match?.params.name)
    const [taxPercentage, setTaxPercentage] = useState("")
    const [taxError, setTaxError] = useState("")
    const [loading, setloading] = useState(false)
    const [categoryId, setCategoryId] = useState<any>("")
    const [imageError, setImageError] = useState("")
    const [selectedFile, setSelectedFile] = useState<any>(null)
    const [existingImage, setExistingImage] = useState("")
    const fileInputRef = useRef<HTMLInputElement>(null)
    const { authState } = useContext(GlobalContext);

    const handleTaxChange = (value: string) => {
        setTaxError("");
        if (value === "") {
            setTaxPercentage("");
            return;
        }
        const val = Number(value);
        if (isNaN(val)) return;
        if (val < 0) return;
        if (val > 100) return;
        if (value.includes(".")) {
            const parts = value.split(".");
            if (parts[1].length > 2) return;
        }
        setTaxPercentage(value);
    }

    const [category, setCategory] = useState({
        data: []
    })
    const [state, setState] = useState({
        category_id: {
            name: ""
        }
    })

    const fileUpload = async () => {
        try {
            const apiRes = await henceforthApi.Common.do_spaces_file_upload("file", selectedFile)
            const data = apiRes.data
            return data.file_name
        } catch (error) {
            handleError(error)
            return ""
        }
    }

    const initialiseSubCategory = async () => {
        try {
            let apiRes = await henceforthApi.Category.detailsSubCategory(match?.params.id)
            setState(apiRes?.data)
            setSubCategoryName(apiRes?.data?.name)
            // setTaxPercentage(apiRes?.data?.tax_percentage ? apiRes?.data?.tax_percentage.toString() : "")
            setCategoryId(apiRes?.data?.category_id?._id)
            setExistingImage(apiRes?.data?.image || "")
        } catch (error) {
            handleError(error)
        }
    }
    const initialiseCategory = async () => {
        try {
            const apiRes = await henceforthApi.Category.listCategory()
            setCategory(apiRes?.data)
        } catch {
            console.log("error")
        }
    }

    const editCategory = async (e: any) => {

        e.preventDefault()
        if (!subCategoryName) {
            return setCategoryError("Please enter sub-category name")
        }
        // if (!taxPercentage) {
        //     return setTaxError("Please enter tax percentage")
        // }
        setloading(true)
        try {
            let image = existingImage
            if (selectedFile) {
                const uploadedImage = await fileUpload()
                if (uploadedImage) {
                    image = uploadedImage
                }
            }
            
            const data = {
                _id: match?.params.id,
                name: subCategoryName,
                category_id: categoryId,
                // tax_percentage: Number(taxPercentage),
                is_deleted: false,
                ...(image && { image: image }),
                language: authState.lang
            }
            let apiRes = await henceforthApi.Category.editSubCategory(data)
            toast.success("Category Updated Successfully")
            window.history.back()
        } catch (error) {
            handleError(error)
        } finally {
            setloading(false)
        }
    }

    useEffect(() => {
        initialiseSubCategory()
    }, [authState?.lang])
    useEffect(() => {
        initialiseCategory()
    }, [authState?.lang])
    console.log(categoryId)

    return (
        <>
            <section className="breadcrum-box">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            {/* title  */}
                            <h2 className="fw-semibold">Edit Sub-Categories</h2>
                            {/* breadcrum  */}
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item active fw-bold">Edit Sub-Categories</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            {/* page  */}
            <div className='page-spacing'>
                <section className='product-detail'>
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-sm-10 col-md-6 col-lg-5 col-xl-4 col-xxl-3">
                                {/* Title  */}
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>Edit Sub-Categories</h5>
                                    </div>
                                    <div className="common-card-content">
                                        <form onSubmit={editCategory} >
                                            {/* Upload image */}
                                            <div className='upload-fields-box mb-4'>
                                                <label className="mb-1 fw-bold">Sub-Category Image:</label>
                                                <div className='d-flex align-items-start gap-3' style={{ position: 'relative' }}>
                                                    <div 
                                                        style={{ 
                                                            width: '100px', 
                                                            height: '100px', 
                                                            border: '2px dashed #ccc', 
                                                            borderRadius: '8px', 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            justifyContent: 'center',
                                                            backgroundColor: '#f8f9fa',
                                                            flexShrink: 0,
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => (fileInputRef.current as HTMLInputElement)?.click()}
                                                    >
                                                        {selectedFile ? (
                                                            <img 
                                                                src={URL.createObjectURL(selectedFile)} 
                                                                alt="Sub-Category" 
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} 
                                                            />
                                                        ) : existingImage ? (
                                                            <img 
                                                                src={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${existingImage}`} 
                                                                alt="Sub-Category" 
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} 
                                                            />
                                                        ) : (
                                                            <i className="fa fa-image" style={{ fontSize: '40px', color: '#6c757d' }}></i>
                                                        )}
                                                    </div>
                                                    <div className='flex-grow-1' style={{ position: 'relative' }}>
                                                        <input 
                                                            type="file" 
                                                            ref={fileInputRef}
                                                            accept="image/png,image/jpeg,image/jpg" 
                                                            onChange={(e: any) => { 
                                                                setSelectedFile(e.target.files[0])
                                                                setImageError("")
                                                            }} 
                                                            style={{ display: 'none' }}
                                                        />
                                        
                                                    </div>
                                                </div>
                                                <p><small><strong>Note:-</strong> Please upload only .jpg and .png format only. (Optional)</small></p>
                                                {/* error msg  */}
                                                <div className={`${imageError ? "invalid-feedback d-block" : ""}`}>
                                                    {imageError}
                                                </div>
                                            </div>
                                            {/* Input Field  */}
                                            <div className="form-fields-box mb-4 is-invalid">
                                                <label className="mb-1 fw-bold">SubCategory Name:</label>
                                                <input type="text" placeholder="Category Name" className={`form-control ${categoryNameError ? `is-invalid` : ``} rounded-0`} value={subCategoryName}
                                                    onChange={(e: any) => { if (categoryNameError) { setCategoryError("") } setSubCategoryName(e.target.value) }} />
                                                {/* error msg  */}
                                                <div className={`${categoryNameError ? "invalid-feedback" : ""}`}>
                                                    {categoryNameError}
                                                </div>
                                            </div>
                                            {/* Tax (%)  */}
                                            {/* <div className="form-fields-box mb-3 is-invalid">
                                                <label className="mb-1 fw-bold">Tax (%):</label>
                                                <input type="number" className={`form-control ${taxError ? `is-invalid` : ""} `} placeholder="Enter Tax Percentage" value={taxPercentage} onChange={(e) => handleTaxChange(e.target.value)} onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} />
                                                <div className={`${taxError ? "invalid-feedback" : ""}`}>
                                                    {taxError}
                                                </div>
                                            </div> */}
                                            <div className="form-select-box mb-3 is-invalid">
                                                <label className="mb-1 fw-bold">Select Category</label>
                                                <select className="form-select" aria-label="Default select example" value={categoryId}
                                                    onChange={(e) => { setCategoryError(""); setCategoryId(e.target.value) }}
                                                >
                                                    <option value="">{state?.category_id?.name}</option>
                                                    {category?.data.map((response: any) => <option value={response._id}>{response.name}</option>)}
                                                </select>
                                            </div>

                                            {/* Button  */}
                                            <div className="button-box">
                                                <button type="submit" className='btn btn-theme w-100' disabled={loading}>{loading ? <Spinner /> : "Edit Category"}</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}
export default SubCategoryEdit